import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { PageCollection } from '../index'

export const setupPageReplication = (
  collection: PageCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'documents',
    displayName: 'Page',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      projectId: doc.projectId,
      parentPageId: doc.parentDocumentId || null, // Backend sends parentDocumentId
      title: doc.title,
      slug: doc.slug,
      icon: doc.icon,
      iconType: doc.iconType,
      iconColor: doc.iconColor || null,
      sortOrder: doc.sortOrder,
      coverImageUrl: doc.coverImageUrl || null,
      coverImageType: doc.coverImageType || null,
      coverImageMeta: doc.coverImageMeta || null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      projectId: state.projectId,
      parentDocumentId: state.parentPageId || null, // Frontend uses parentPageId, backend expects parentDocumentId
      title: state.title,
      slug: state.slug,
      icon: state.icon,
      iconType: state.iconType,
      iconColor: state.iconColor,
      sortOrder: state.sortOrder,
      coverImageUrl: state.coverImageUrl,
      coverImageType: state.coverImageType,
      coverImageMeta: state.coverImageMeta,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
